<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Apply Changes</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card>
                            <v-card-title>Choose data to change</v-card-title>
                            <v-card-text class="pb-8"> 
                                <div>
                                    <v-row>
                                        <v-col class="text-left">
                                            <v-radio-group mandatory>
                                                <v-radio value="control" @click="mode = 'control'">
                                                    <template v-slot:label>
                                                       <div class="black--text">Control Settings</div>
                                                    </template>
                                                </v-radio>
                                                <v-radio value="schedule" @click="mode = 'schedule'">
                                                    <template v-slot:label>
                                                        <div class="black--text">Schedule Settings</div>
                                                    </template>
                                                </v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>  
                    </v-form>  
                </v-card-text>
                <div>
                    <v-card-actions class="mr-4 mt-n5">
                        <v-spacer></v-spacer>
                        <v-btn color="accent" small class="ml-2" @click="save(mode)">Save</v-btn>
                    </v-card-actions>
                </div>
                <v-dialog v-model="openDelete" persistent width="370" class="align-center">
                    <template>
                        <v-card height="auto">
                        <v-toolbar :elevation="0" color="primary" dark>
                            <v-toolbar-title>Delete group</v-toolbar-title>
                        </v-toolbar>
                            <v-form ref="form" class="text-center my-3">
                                Do you want to delete group?
                            </v-form>
                            <div align="right" class="align-content-end mx-4">
                                <v-btn color="danger" 
                                    small
                                    class="white--text mx-2 mb-3" 
                                    @click="deleteOfc"
                                    >Delete
                                </v-btn>
                                <v-btn color="danger" 
                                    small 
                                    text
                                    class="mb-3"
                                    @click="close"
                                    >Cancel
                                </v-btn>
                            </div>
                        </v-card>
                    </template>
                </v-dialog>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="success" :timeout="3000">
            Group deleted successfully
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="success = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import formDelete from './formDelete'
import formConfirmation from './formConfirmation'
export default {
    name: 'formApply',
    props: ['open', 'metersToChange', 'originalMeters', 'group', 'on', 'off'],
    computed:{ 
        ...mapState({ 
            meters: state => state.meters.meters,
            groupMeters: state => state.meters.groupMeters,
            sky_ofs: state => state.user.sky_ofs
        })},
    components: { formDelete, formConfirmation },
    data() {
        return {
            selectedMeters: [],
            groupName: '',
            openDelete: false,
            success: false,
            groupData: {name: '', meters: []},
            mode: 'control'
        }
    },
    methods: {
        ...mapActions({ controlMeter: 'meters/controlMeter', activeSuntime: 'meters/activeSuntime', scheduleMeter: 'meters/scheduleMeter'}),
        close(){
            this.openDelete = false
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.groupName = ''
            this.selectedMeters = []
        },
        async save(mode){
            switch (mode) {
                case 'control':
                    if (this.metersToChange.length > 1) {
                        for (let index = 0; index < this.metersToChange.length; index++) {
                            const element = this.originalMeters[this.metersToChange[index]].name
                            await this.controlMeter({
                                meter: element,
                                control: this.group.control,
                                fotocelda: this.group.photocell
                            })
                        }
                    } else {
                        const element = this.originalMeters[this.metersToChange[0]].name
                        await this.controlMeter({
                            meter: element,
                            control: this.group.control,
                            fotocelda: this.group.photocell
                        })
                    }
                    break;
                case 'schedule':
                    let active = this.group.suntime
                    if (this.metersToChange.length > 1) {
                        for (let index = 0; index < this.metersToChange.length; index++) {
                            const element = this.originalMeters[this.metersToChange[index]].name
                            if (active) {
                                await this.activeSuntime({
                                    meter: element,
                                    data: { active }
                                })
                            } else {
                                await this.scheduleMeter({
                                    meter: element,
                                    data: {
                                        hours: this.on.hours,
                                        minutes: this.on.minutes,
                                        control: 'ON',
                                        timezone: this.sky_ofs
                                    }  
                                })
                                await this.scheduleMeter({
                                    meter: element,
                                    data: {
                                        hours: this.off.hours,
                                        minutes: this.off.minutes,
                                        control: 'OFF',
                                        timezone: this.sky_ofs
                                    }  
                                })
                                this.originalMeters[this.metersToChange[index]].suntime = false    
                            }    
                        }
                    } else {
                        const element = this.originalMeters[this.metersToChange[0]].name
                        if (active) {
                                await this.activeSuntime({
                                    meter: element,
                                    data: { active }
                                })
                            } else {
                                await this.scheduleMeter({
                                    meter: element,
                                    data: {
                                        hours: this.on.hours,
                                        minutes: this.on.minutes,
                                        control: 'ON',
                                        timezone: this.sky_ofs
                                    }  
                                })
                                await this.scheduleMeter({
                                    meter: element,
                                    data: {
                                        hours: this.off.hours,
                                        minutes: this.off.minutes,
                                        control: 'OFF',
                                        timezone: this.sky_ofs
                                    }  
                                })
                                this.originalMeters[this.metersToChange[0]].suntime = false
                            }
                    }
                    break;
                default:
                    break;
            }
            this.$emit('save')
            this.close()
        },
        show(item){
            return item
        },
        async remove(item) {
            const index = this.groupData.meters.indexOf(item)
            if (index >= 0) this.groupData.meters.splice(index, 1)
            await this.deleteFromGroup({meters: [item]})
        },
        async confirmDelete(){
            this.openDelete = true
        },
        async deleteOfc(){
            await this.deleteGroup({ name: this.group_id, meters: this.group_meters.meters })
            this.sleep(1000).then(() => { this.close(); })
            this.success = true
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    },
}
</script>

<style scoped>
</style>